import { utils } from '@febos-io/common';

export const getCompanyList = (page, limit = 1, filter = undefined) => ({
  path: 'v1/companies',
  params: {
    page,
    limit,
    ...{ ...filter && ({ filter }) }
  }
});

export const getCompany = (id) => ({
  path: `v1/companies/${id}`
});

export const saveCompany = (
  {
    identificationNumber,
    businessName,
    business,
    acteco,
    status = 'active'
  }
) => ({
  path: 'v1/companies',
  method: utils.METHOD.POST,
  content: {
    identificationNumber,
    businessName,
    business,
    acteco,
    status
  }
});

export const updateCompany = (
  companyId,
  {
    identificationNumber,
    businessName,
    business,
    acteco,
    status = 'active'
  }
) => ({
  path: `v1/companies/${companyId}`,
  method: utils.METHOD.PUT,
  content: {
    identificationNumber,
    businessName,
    business,
    acteco,
    status
  }
});
